import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Button,
} from "@mui/material";

const headerStyle = {
  color: "white",
  fontWeight: 600,
  fontSize: "14px",
  padding: "16px 20px",
  borderBottom: "2px solid #000080",
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: "#bb1ccc !important",
};

const cellStyle = {
  padding: "16px 20px",
  fontSize: "14px",
};

const ProfilingResultsTable = ({
  rows = [],
  onViewPlot = () => {},
  containerSx = {},
}) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        marginTop: "20px",
        maxHeight: "500px",
        overflow: "auto",
        ...containerSx,
      }}
    >
      <Table sx={{ minWidth: 650 }} stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={headerStyle}>Column</TableCell>
            <TableCell sx={headerStyle}>Data Type</TableCell>
            <TableCell sx={headerStyle}>CDE</TableCell>
            <TableCell sx={headerStyle}>Business Term</TableCell>
            <TableCell sx={headerStyle}>Null %</TableCell>
            <TableCell sx={headerStyle}>Statistics</TableCell>
            <TableCell sx={headerStyle}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rows || []).map((col, index) => (
            <TableRow
              key={col.column_name || index}
              sx={{
                backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                "&:hover": {
                  backgroundColor: "#f0f8ff",
                  transition: "background-color 0.2s ease",
                },
              }}
            >
              <TableCell
                sx={{
                  ...cellStyle,
                  fontWeight: 600,
                  color: "#2c3e50",
                }}
              >
                {col.column_name || "N/A"}
              </TableCell>
              <TableCell sx={{ ...cellStyle, color: "#555" }}>
                {col.type || "N/A"}
              </TableCell>
              <TableCell sx={cellStyle}>
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    px: 2,
                    py: 0.5,
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    backgroundColor: col.isCde ? "#e8f5e8" : "#fff3e0",
                    color: col.isCde ? "#2e7d32" : "#f57c00",
                  }}
                >
                  {col.isCde ? "Yes" : "No"}
                </Box>
              </TableCell>
              <TableCell sx={{ ...cellStyle, color: "#555" }}>
                {col.businessterm === null || col.businessterm === undefined
                  ? "N/A"
                  : col.businessterm}
              </TableCell>
              <TableCell sx={{ ...cellStyle, color: "#555" }}>
                {col.nullPercentage === null ||
                col.nullPercentage === undefined
                  ? "N/A"
                  : `${col.nullPercentage || 0}%`}
              </TableCell>
              <TableCell sx={{ ...cellStyle, color: "#555" }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <span>
                    <strong>Mean:</strong>{" "}
                    {col.mean === null || col.mean === undefined
                      ? "N/A"
                      : col.mean}
                  </span>
                  <span>
                    <strong>Max:</strong>{" "}
                    {col.max === null || col.max === undefined
                      ? "N/A"
                      : col.max}
                  </span>
                  <span>
                    <strong>Min:</strong>{" "}
                    {col.min === null || col.min === undefined
                      ? "N/A"
                      : col.min}
                  </span>
                </Box>
              </TableCell>
              <TableCell sx={cellStyle}>
                <Button
                  variant="text"
                  size="small"
                  sx={{
                    color: "#bb1ccc",
                    fontWeight: 600,
                    "&:hover": {
                      backgroundColor: "#f0f8ff",
                    },
                  }}
                  onClick={() => onViewPlot(col)}
                >
                  View Plot
                </Button>
              </TableCell>
            </TableRow>
          ))}
          {!rows?.length && (
            <TableRow>
              <TableCell
                colSpan={7}
                sx={{ ...cellStyle, textAlign: "center", color: "#6b7280" }}
              >
                No columns found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ProfilingResultsTable;


